export const specialCategories = ['/other', '/unsure'];
export const minCategorySelectLength = specialCategories.length;

export const maxAnnotationDepth = 4;
export const annotationDepthArray = Array.from(Array(maxAnnotationDepth).keys());
